import React, { useState } from 'react';
import { Link, useLocation } from 'react-router';
import { useQuery } from '@apollo/client/react';
import { BrowseEventsDocument, BrowseEventsQuery } from 'graphql/queries.generated';
import { BrowseOrganizationsDocument, BrowseOrganizationsQuery } from 'graphql/queries.generated';
import styles from 'pages/Browse.module.css';
import EventCard from 'components/EventCard';
import GroupCard from 'components/GroupCard';

const Browse: React.FC = () => {
    const location = useLocation();
    const isEventsView = location.pathname === '/browse-events';
    
    const { loading: eventsLoading, error: eventsError, data: eventsData } = useQuery<BrowseEventsQuery>(
        BrowseEventsDocument,
        {
            variables: { region: "Portland, OR" },  // TODO: fix this when region picking is implemented
            skip: !isEventsView
        }
    );

    const { loading: groupsLoading, error: groupsError, data: groupsData } = useQuery<BrowseOrganizationsQuery>(
        BrowseOrganizationsDocument,
        {
            variables: { region: "Portland, OR" },  
            skip: isEventsView
        }
    );

    const loading = isEventsView ? eventsLoading : groupsLoading;
    const error = isEventsView ? eventsError : groupsError;

    const renderNav = () => (
        <nav className={styles.nav}>
            {isEventsView ? (
                <span>Events</span>
            ) : (
                <Link to="/browse-events">Events</Link>
            )}
            {isEventsView ? (
                <Link to="/browse-groups">Groups</Link>
            ) : (
                <span>Groups</span>
            )}
        </nav>
    );

    if (loading) {
        return (
            <div className={styles.browse}>
                {renderNav()}
                <h1>{isEventsView ? 'Browse Events' : 'Browse Groups'}</h1>
                <p className={styles.loading}>Loading {isEventsView ? 'events' : 'organizations'}...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className={styles.browse}>
                {renderNav()}
                <h1>{isEventsView ? 'Browse Events' : 'Browse Groups'}</h1>
                <p className={styles.error}>Error loading {isEventsView ? 'events' : 'organizations'}: {error.message}</p>
            </div>
        );
    }

    const events = eventsData?.events || [];
    const organizations = groupsData?.organizations || [];

    return (
        <div className={styles.browse}>
            {renderNav()}
            {isEventsView ? (
                <>
                    {events.length === 0 ? (
                        <p className={styles.noResults}>No events found.</p>
                    ) : (
                        <div className={styles.grid}>
                            {events.map((event) => (
                                <EventCard key={event.eventId} event={event} />
                            ))}
                        </div>
                    )}
                </>
            ) : (
                <>
                    {organizations.length === 0 ? (
                        <p className={styles.noResults}>No organizations found.</p>
                    ) : (
                        <div className={styles.grid}>
                            {organizations.map((org) => (
                                <GroupCard key={org.organizationId} organization={org} />
                            ))}
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default Browse;

